const ComponentBase = require('../../base/ComponentBase');
const RenderUtil = require('../../utils/RenderUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 要素高亮
 * @augments G.base.ComponentBase
 * @alias G.common.FeatureHighlight
 * @param {Object} options
 * @param {G.Map} options.map 地图对象
 * @param {String} [options.id] 标识
 * @param {String} [options.name] 名称
 * @param {g2.carto.ElementLayer} [options.layer] 高亮图层
 * @param {Integer} [options.zIndex] 高亮图层
 * @param [opts.blink] {Object} 配置
 * @param [opts.blink.interval] {Object} 闪烁时间间隔
 * @param [opts.blink.duration] {Object} 闪烁持续时间
 * @example
 * //使用示例代码
 * //todo
 */
let component = ComponentBase.extend({
    options: {},
    initialize (options) {
        ComponentBase.prototype.initialize.call(this, options);
        if (!options.layer) {
            var hightLightLayer = new g2.carto.ElementLayer({
                id: options.id || "highlightLayer",
                name: options.name || "highlightLayer",
                map: options.map,
                zIndex: options.zIndex || 100
            })
            this.layer = hightLightLayer;
        } else {
            this.layer = options.layer
        }
        if (!!options.blink && !!options.blink.interval && !!options.blink.duration) {
            this.interval = options.blink.interval;
            this.duration = options.blink.duration;
        } else {
            this.interval = 200;  //间隔200毫秒
            this.duration = 1600;  //持续时长
        }
        
    },
    /**
     * 加载
     * @method
     * @memberOf G.common.FeatureHighlight.prototype
     */
    load(){
        this.map.addLayer(this.layer);
        this._toolTipWare = new g2.widget.TooltipWare({
            map: this.map
        });
    },
    /**
     * 添加高亮
     * @method
     * @memberOf G.common.FeatureHighlight.prototype
     * @param id {String} element标识
     * @param opts {Object} 配置
     * @param opts.data {Object} element数据
     * @param opts.data.type {String} 类型: wkt, geojson
     * @param opts.data.geom {String} 几何对象值: wkt, geojson
     * @param opts.style {Object} 样式配置
     * @param [opts.blink] {Object} 配置
     * @param [opts.blink.interval] {Object} 闪烁时间间隔
     * @param [opts.blink.duration] {Object} 闪烁持续时间
     *
     */
    addHighlight(id, opts){
        //构建g2.sfs.Element
        this.removeHighlight(id);
        
        if (!(CommonUtil.isArray(opts))) {
            opts = [opts];
        }
        opts.forEach(opt => {
            if (opt && opt.style && opt.style.type == "GifMarkerSymbol") {
                const tooltip = this._createGifToolTip(id, opt);
                this._toolTipWare.add(tooltip);
            } else if (opt && opt.style && opt.style.type == "Custom") { // 支持自定义dom方式
                const tooltip = this._createCustomToolTip(id, opt);
                this._toolTipWare.add(tooltip);
            } else {
                var elements = this._elementConstructor(id, opt);
                elements.forEach(element => {
                    this.layer.add(element);
                    if (opt.blink && opt.blink.enable === false) {
                    
                    } else {
                        if (opt.blink && opt.blink.interval && (opt.blink.interval + "") != "0") {
                            this._setElementInterval(id, opt.blink, element);
                        } else {
                            var blinkOpt = {
                                interval: this.interval,
                                duration: this.duration
                            }
                            this._setElementInterval(id, blinkOpt, element);
                        }
                    }
                    
                });
            }
        });
        
    },
    /**
     * 移除高亮
     * @method
     * @memberOf G.common.FeatureHighlight.prototype
     * @param id {String} 高亮元素标识
     */
    removeHighlight(id){
        //清除图层元素
        if (!!this.layer.elements) {
            for (let index = this.layer.elements.length - 1; index > -1; index--) {
                const element = this.layer.elements[index];
                if (element.id == id) {
                    this.layer.remove(element);
                }
            }
        }
        
        //清除闪烁事件
        if (!!this._intervalObj[id]) {
            for (let index = 0; index < this._intervalObj[id].length; index++) {
                clearInterval(this._intervalObj[id][index]);
            }
        }
        
        this._toolTipWare.remove(id);
        delete this._intervalObj[id];
    },
    /**
     * 清除所有高亮
     * @method
     * @memberOf G.common.FeatureHighlight.prototype
     */
    clearHighlight(){
        //清除图层元素
        this.layer.clear();
        this._toolTipWare.clear();
        //清除闪烁事件
        var object = this._intervalObj;
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                const _interval = object[key];
                for (let index = 0; index < _interval.length; index++) {
                    const element = _interval[index];
                    clearInterval(element);
                }
            }
        }
        this._intervalObj = {};
    },
    /**
     * 卸载
     * @method
     * @memberOf G.common.FeatureHighlight.prototype
     */
    unload(){
        this.clearHighlight();
        this.map.removeLayer(this.layer);
    },
    /**
     * 销毁
     */
    destroy () {
        ComponentBase.prototype.destroy.call(this);
    },
    
    _createTooltip(id, anchor, content, offset){
        offset = offset || [-10, -10];
        var tooltip = new g2.widget.Tooltip({
            id: id, //唯一标示
            anchor: anchor, //提示在地图上停靠位置
            content: content, //提示内容
            layerId: this.layer.getLayerId(), //提示所在图层ID
            offset: offset //位置偏移量
        });
        return tooltip;
    },
    
    _createGifToolTip(id, opts){
        var style = opts.style;
        if (!style.options) {
            return;
        }
        var data = opts.data;
        var offset = [-10, -10];
        if (style.options.offsetx) {
            offset[0] = style.options.offsetx;
        }
        if (style.options.offsety) {
            offset[1] = style.options.offsety;
        }
        var content = '<img id="' + id + '" src="' + style.options.source + '"/>';
        return this._createTooltip(id, this._geometryConstructor(data), content, offset);
    },
    
    _createCustomToolTip(id, opts){
        var style = opts.style;
        if (!style.options) {
            return;
        }
        const anchor = this._geometryConstructor(opts.data);
        var offset = [-10, -10];
        if (style.options.offsetx) {
            offset[0] = style.options.offsetx;
        }
        if (style.options.offsety) {
            offset[1] = style.options.offsety;
        }
        return this._createTooltip(id, anchor, style.options.content, offset);
    },
    /**
     * element设置interval
     * @ignore
     * @param id {String} 高亮元素标识
     * @param option {Object} 高亮元素选项
     * @param element {Object} 高亮元素
     */
    _setElementInterval(id, option, element){
        var repeatCount = null;
        if (option.duration) {
            repeatCount = parseInt(parseFloat(option.duration) / parseFloat(option.interval));
        }
        var _layer = this.layer;
        if (!this._intervalObj[id]) {
            this._intervalObj[id] = [];
        }
        this._intervalObj[id].push(this._getIntervalFunc(option.interval, repeatCount, element, _layer));
    },
    
    /**
     * 构造interval
     * @ignore
     * @param interval {Integer} 间隔：单位毫秒
     * @param repeatCount {Integer} 重复次数
     * @param element {Object} 高亮元素
     * @param layer {Object} 高亮图层
     */
    _getIntervalFunc(interval, repeatCount, element, layer){
        var counter = 0;
        var _intervalFunc = setInterval(
            function () {
                
                if (repeatCount != null) {
                    if (counter <= repeatCount) {
                        layer.showElement(element, (counter % 2) == 0)
                    } else {
                        layer.remove(element);
                        clearInterval(_intervalFunc);
                    }
                } else {
                    layer.showElement(element, (counter % 2) == 0)
                }
                counter++;
            }, interval);
        return _intervalFunc;
    },
    //element对应的闪烁事件k-v map, k:id, v:interval
    _intervalObj: {},
    
    //构建g2.sfs.Element
    _elementConstructor(id, opts){
        var elements = [];
        if (!opts.data) {
            return;
        }
        if (!(CommonUtil.isArray(opts.data))) {
            opts.data = [opts.data];
        }
        opts.data.forEach(data => {
            var element = new g2.sfs.Element({
                id: id,
                geometry: this._geometryConstructor(data),
                symbol: this._symbolConstructor(opts.style),
            });
            elements.push(element);
        });
        
        return elements;
    },
    //构建g2.sfs.Geometry
    //todo
    _geometryConstructor(data){
        var geom = new g2.sfs.Geometry();
        if (data.type.toLowerCase() == "wkt") {
            geom = g2.sfs.GeometryFactory.createGeometryFromWkt(data.geom, this.map.getSrid());
        } else if (data.type.toLowerCase() == "geojson") {
            geom = g2.sfs.GeometryFactory.createGeometryFromGeoJson(data.geom, this.map.getSrid());
        }
        return geom;
    },
    //构建g2.sfs.Symbol
    _symbolConstructor(style){
        var symbol = RenderUtil.object2Symbol(style);
        return symbol;
    },
    
});
module.exports = component;
